import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Orange.svg",
  "use": "Orange.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Orange.svg\"><path d=\"M32,56c-13,0-21-8.9543-21-20s8-20,21-20,21,8.9543,21,20S45,56,32,56Zm0-42c-1.1046,0-2-.4477-2-1a1.9836,1.9836,0,0,0-2-2c-1.1317,0-2.5649,2-7,2s-7-2.8318-7-4,4.0044-4,10-4,10,3.3891,10,8C34,13.5523,33.1046,14,32,14Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol